module.exports = __webpack_public_path__ + "fonts/Gotham-Light.0198d00e.otf";